import { useAtomValue } from 'jotai';
import { exportModalDataAtom } from '@/atoms/exporting';
import { formatFileName } from '@/utils/array';
import { useExportTitle } from './useExportTitle';

export const useExportModalInfo = () => {
  const { visName, templateName, secondaryTitlePrefix, customWidth } =
    useAtomValue(exportModalDataAtom) ||
    /* istanbul ignore next: shouldn't ever get here as we only call this thing if the data is not null */ {};

  const title = useExportTitle();
  const fileName = formatFileName([title, templateName, visName]);

  return { title, templateName, secondaryTitlePrefix, fileName, customWidth };
};
